export default __webpack_public_path__ + "locales/el-GR/DeleteSelfProfileDialog.json?hash=cfff159f46356a98cb084d0cfd90a104";